export default __webpack_public_path__ + "static/car-play-a57b59a06f82938a904ddad1a5c2db5c.png";